import { DYAD_ICON, TRIAD_ICON, INDIVIDUAL_ICON, FOCUS_GROUP_ICON } from "../utills/icons";

export const SCREENER_DRAFT = 0;
export const SCREENER_ACTIVE = 1;

export const QUESTION_CATEGORY_RADIO = 0;
export const QUESTION_CATEGORY_GROUP = 2;
export const QUESTION_CATEGORY_CHECKBOX = 1;

export const USE_OTHER_OPTION_NO = false;
export const USE_OTHER_OPTION_YES = true;

export const RESULT_FAIL = 0;
export const RESULT_PASS = 1;

export const OP_OR = "or";
export const OP_AND = "and";
export const OP_EQUALS = "e";
export const OP_NOT_EQUALS = "ne";
export const OP_ALWAYS = "always";
export const TYPE_QUESTION = "question";
export const TYPE_OPTION = "option";

export const OPTION_TYPE = { MUST: "must", MAY: "maybe", REJECT: "reject" };

export const LOGIC_ACTION_JUMP = "jump";
export const LOGIC_DETAILS_TYPE_TASK = "task";
export const LOGIC_DETAILS_TYPE_END_OF_TEST = "end_of_test";
export const LOGIC_DETAILS_TYPE_END_TEST_WITH_DISQUALIFICATION = "end_test_disqualify";
export const LOGIC_DETAILS_TYPE_NEXT_TASK = "next_task";

export const TEST_DEVICE_TYPE_DESKTOP = "1"; // Desktop

export const ANALYSIS_TYPE_VIDEO_CLIP = "0";
export const ANALYSIS_TYPE_NOTES = "1";
export const ANALYSIS_TYPE_BOOKMARKS = "2";
export const ANALYSIS_TYPE_ANNOTATIONS = "3";
export const ANALYSIS_TYPE_TRANSCRIPTS = "4";
export const ANALYSIS_TYPE_TRANSLATION = "5";

export const ANALYSIS_TYPE_VIDEO_CLIP_TEXT = "Clip";
export const ANALYSIS_TYPE_NOTES_TEXT = "Note";
export const ANALYSIS_TYPE_BOOKMARKS_TEXT = "Bookmark";
export const ANALYSIS_TYPE_ANNOTATIONS_TEXT = "Marker";
export const ANALYSIS_TYPE_TRANSCRIPTS_TEXT = "Transcription";
export const ANALYSIS_TYPE_TRANSLATION_TEXT = "Translation";

export const FILTER_SPACE_BY_RESPONDENT_SESSION = "FILTER_SPACE_BY_RESPONDENT_SESSION";
export const FILTER_SPACE_BY_SEARCH_KEYWORDS = "FILTER_SPACE_BY_SEARCH_KEYWORDS";
export const FILTER_SPACE_BY_TAGS = "FILTER_SPACE_BY_TAGS";

export const REEL_INITIAL = 0;
export const REEL_READY = 1;
export const REEL_PROCESSING = 2;

export const SHOW_ME_HOW_TEXT = 0;
export const SHOW_ME_HOW_CLIP = 1;
export const SHOW_ME_HOW_REEL = 2;

export const ACTIVE_TAB_EVERYTHING = -1;
export const ACTIVE_TAB_ALL = 0;
export const ACTIVE_TAB_REELS = 1;
export const ACTIVE_TAB_CLIPS = 2;
export const ACTIVE_TAB_AREAS = 3;
export const ACTIVE_TAB_INSIGHTS = 4;

export const ACTIVE_TAB_EVERYTHING_LABEL = "All Tabs";
export const ACTIVE_TAB_ALL_LABEL = "All Tagged Items";
export const ACTIVE_TAB_REELS_LABEL = "Highlight Reels";
export const ACTIVE_TAB_CLIPS_LABEL = "All Video Clips";
export const ACTIVE_TAB_AREAS_LABEL = "All Notes & Text";
export const ACTIVE_TAB_INSIGHTS_LABEL = "Insights";

export const PINNED_CLIPS_TAB_ACTIVE = 0;
export const OPTION_DOWNLOAD_CLIP = "downloadClip";
export const OPTION_UNPIN_CLIP = "unpinClip";
export const OPTION_CREATE_NEW_HIGHLIGHT_REEL = "newHighlightReel";
export const OPTION_REMOVE_CLIP_FROM_REEL = "removeClipFromReel";
export const OPTION_VIEW_FULL_RECORDING = "viewFullRecording";
export const OPTION_SHARE_CLIP = "shareClip";
export const OPTION_ADD_COMMENT = "addComment";
export const OPTION_EDIT_TEXT = "editText";

export const EXPANDABLE_TYPE_TEXT = 0;
export const EXPANDABLE_TYPE_TAG = 1;

export const MAX_LENGTH = {
  TEST_NAME: 40,
  THANK_YOU: 800,
  SURVEY_OPTIONS: 255,
  SURVEY_OPTIONS_OLD: 55,
  SURVEY_QUESTION: 800,
  SURVEY_QUESTION_OLD: 300,
  MATRIX_QUESTION: 150,
  WELCOME_MESSAGE: 400,
  TASK_DESCRIPTION: 1300,
  SURVEY_OPTIONS_BROWSER_TEST: 150,
  SURVEY_QUESTION_BROWSER_TEST: 500,
};

export const MAX = {
  TASKS: 70,
  SURVEY_IMAGES: 10,
  SURVEY_IMAGE_SIZE: 2, // Image size is in the MB
  TASK_IMAGE_SIZE: 5, // Image size is in the MB
  MATRIX_QUESTION_OPTIONS: 10,
  NDA_FILE_SIZE: 200, // Size is in kbps (200kb)
  NDA_FILES: 10, // Number of NDA files
  BRANDING_LOGO: 1,
};

export const YESNO = { NO: 0, YES: 1 };

// Lifecycle state of a video clip, stored in `is_clip_ready`. Clips are saved as
// DRAFT (no file generated); the physical clip is only generated on download
// (PROCESSING -> READY). READY stays 1 for backward compatibility.
export const CLIP_STATE = { DRAFT: 0, READY: 1, PROCESSING: 2, FAILED: 3 };

export const INCLUDE_NDA = { OFF: 0, ON: 1 };

export const TRANSCRIPTION = { ENABLED: 1, DISABLED: 0 };

export const TRANSCRIPTION_STATUS = { NOT_SENT: 0, PENDING: 1, COMPLETED: 2, COMPLETED_EMPTY: 3 };

export const TRANSLATION_TOOL = { GOOGLE_TRANSLATE: 1, AI_TRANSLATE: 2, BATCH_TRANSLATE: 3 };

export const TRANSLATION_TYPE = { TRANSLATE: 0, SHORTEN: 1, REPHRASE: 2 };

export const DEVICE_TYPE = { COMPUTER: 1, TABLET: 2, MOBILE: 3, TABLET_AND_MOBILE: 4, TABLET_IPAD: 5, ANY: 6 };

// Platform the recorder is running on - drives which MediaRecorder mime types we prefer
export const RECORDING_DEVICE = { IOS: "ios", ANDROID: "android", DESKTOP: "desktop" };
export const RECORDING_BROWSER = { CHROME: "chrome", SAFARI: "safari", OTHERS: "others" };

export const INITIAL_TEST_TYPE = {
  DESIGN_PROTOTYPE_TEST: "design_prototype",
  MOBILE_APP_TEST: "mobile_app",
  WEBSITE_TEST: "website",
};

export const TEST_TYPE = {
  MODERATED: 0,
  WEBSITE: 1,
  ANDROID_APP: 2,
  ANDROID_SDK: 3,
  IOS_APP: 4,
  IOS_SDK: 5,
  MULTIOS_APP: 6,
  INSTANT_SESSION: 7,
};

export const TEST_TYPE_SURVEY = "survey";
export const TEST_TYPE_TASK = "task";
export const TEST_TYPE_MODERATED = "moderated";
export const TEST_TYPE_NORECORDING = "noRecording";
export const TEST_TYPE_CARDSORT = "cardsort";
export const TEST_TYPE_TREETEST = "treetest";
// credit usage test types for the AI moderated and externally uploaded interview sessions
export const TEST_TYPE_AI_INTERVIEW = "aiInterview";
export const TEST_TYPE_EXTERNAL_UPLOADED = "externalUploaded";

export const TEST_STATUS = {
  DRAFT: 0,
  ACTIVE: 2,
  DRYRUN: 4,
  HIDDEN: -1,
  INACTIVE: 1,
  REACTIVE: 11,
  COMPLETED: 3,
  UI_STATUS_COMPLETED: 31,
  UI_STATUS_TERMINATED: 32,
  UI_STATUS_EXPIRED: 33,
  EDIT_TEST: 8,
  SAVED_TEST: 7,
  PREVIEW_TEST: 9,
  TEMP_AB_TEST: -2,
  DELETE_SUFFIX: 6,
  COMPLETED_BY_USER: 5,
  SCREENER_FAILED_BY_USER: -3,
};

export const RECRUIT_OWN_TESTERS = "RECRUIT_OWN_TESTERS";
export const RECRUIT_PANEL_TESTERS = "RECRUIT_PANEL_TESTERS";

export const GENDER = { MALE: 0, FEMALE: 1, BOTH: -1 };

export const RECRUIT_AGE_LIMITS = { MIN: 18, MAX: 60 };
export const RECRUIT_NO_PARTICIPANT_ERR = "Please select at least 1 expected response to launch this test.";
export const RECRUIT_SELF_SOURCED_INSUFFICEINT_ERR = "Insufficient pooled credits. Please check back next month or upgrade your plan.";
export const ENTERPRISE_RECRUIT_SELF_SOURCED_INSUFFICEINT_ERR =
  "You are running out of credits. Please contact support team to top up your balance.";
export const RECRUIT_CREDITS_ERR = "Please ensure you have sufficient credits before you launch the test.";
export const ENTERPRISE_RECRUIT_CREDITS_ERR = "You are running out of credits. Please contact support team to top up your balance.";
export const PAID_RECRUIT_CREDITS_ERR = "Insufficient user panel credits.";
export const EXTRA_UA_CREDITS_ERR = "Please upgrade your plan.";
export const RECRUIT_DEMOGRAPHICS_ERR = "Please check your demographics criteria for errors.";
export const RECRUIT_NATIONALITY_ERR = "Please select at least 1 nationality for your panelists under Recruitment Filters.";

export const TASK_TYPES = {
  EMPTY: -1, // Only for UI (Empty Task)
  DEFAULT: 0, // Default Task (Website Navigation Task)
  BLANK: 1, // Blank Task (Speaking Task)
  IMAGE: 2, // Image Task
  EXTERNAL_PROTOTYPE: 3, // Figma/Marvel/Invision Task
  MOBAPP_PROTOTYPE: 4, // Mobile App Task
  SURVEY: 5, // Survey Task
  GROUP: 6, // Group Task
  FIVESEC: 7, // Five Second Task
  FIRSTCLICK: 8, // First Click Task
  TREE: 9, // Tree Task
  CARDSORT: 10, // Cardsort Task
  HTML_PROTOTYPE: 11, // HTML prototype task (AI-generated or hand-written prototype on a live URL)
};

export const TASK_STATUS = {
  ACTIVE: 0,
  DELETED: 1,
};

export const SURVEY_TYPES = {
  NOTE: "note", // Note Task
  RADIO: "radio",
  TEXT: "textbox",
  MATRIX: "matrix",
  RANKING: "ranking",
  CHECKBOX: "checkbox",
  LIKERT_5PT: "likert-scale-5pt",
  LIKERT_7PT: "likert-scale-7pt",
  LIKERT_10PT: "likert-scale-10pt",
  SIMPLE_INPUT: "simple-input",
  NPS: "nps",
};

export const TASK_TYPE_KEYS = {
  EMPTY_TASK: -1, // Only for UI (Empty Task)
  YESNO_QUESTION: 1,
  RATING_QUESTION: 2,
  OPEN_QUESTION: 3,
  RANK_OPTIONS: 4,
  MULTIPLE_TYPE: 5,
  WEBSITE_TYPE: 6,
  PROTOTYPE_TASK: 7,
  FIVESECOND_TASK: 8,
  IMAGE_TASK: 9,
  SPEAKING_TASK: 10,
  IOS_APP_TASK: 11,
  ANDROID_APP_TASK: 12,
  MULTIOS_APP_TASK: 13,
  FIVESEC_TASK: 14,
  FIRSTCLICK_TASK: 15,
  SIMPLE_INPUT_QUESTION: 16,
  NOTE_TASK: 17,
  MATRIX_QUESTION_TASK: 18,
  TREE_TASK: 19,
  CARDSORT_TASK: 20,
  NPS_QUESTION: 21,
  HTML_PROTOTYPE_TASK: 22, // Same as Task::TASK_UI_TYPE_HTML_PROTOTYPE in Yii
};

export const ANSWER_TYPE = { TEXT: 1, NUMBER: 0 };
export const URL_PATTERN = { EXACT: 1, PARTIAL: 2, PATH_URLS: 3 };
export const LIKERT_TYPES = { SATISFACTION: 1, ENGAGEMENT: 2, NUMBERS: 3, CUSTOM: 4 };
export const SIMPLE_INPUT_TYPES = { NUMBER: 1, TEXT: 0, EMAIL: 2, DATE: 3 };
export const MATRIX_INPUT_TYPES = { FIVE_POINTS: 0, SEVEN_POINTS: 1, TEN_POINTS: 2 };
export const SUCCESS_CRITERIA = { NONE: -1, ANSWER: 1, SUCCESS_URL: 2, GOAL: 3, TIME_COMPLETION: 4, RULES: 5 }; // RULES: HTML prototype success rules

export const SOURCE_INVISION = 0;
export const SOURCE_MARVEL = 1;
export const SOURCE_FIGMA = 2;
export const INTERACTING_TO_CHANGE_SCREEN = { NO_SCREEN: 0, START_SCREEN: 1, END_SCREEN: 2 };

export const PROTO_STATUS_IMPORTING = 0;
export const PROTO_STATUS_IMPORTED = 1;

export const PREVIEW_PROGRESS = {
  SCREENER: "SCREENER",
  AVAILABLE_TEST: "AVAILABLE_TEST",
  NDA: "NDA",
  CONFIRMATION: "CONFIRMATION",
  TEST_DETAILS: "TEST_DETAILS",
  DEMOGRAPHICS: "DEMOGRAPHICS",
  TASK_DETAILS: "TASK_DETAILS",
  SUS_QUESTIONS: "SUS_QUESTIONS",
  TEST_SUBMIT: "TEST_SUBMIT",
  THANK_YOU: "THANK_YOU",
  DISQUALIFY: "DISQUALIFY",
};

export const SUCCESS_TYPE = {
  NULL: -1, // No Criteria Match
  ANSWER: 1, // match with the user answer
  URL: 2, // match with the success urls
  GOAL: 3, // match with the goal
  TIME: 4, // match with the completion time
};

export const IS_REQUIRED = { YES: 1, NO: 0 };

export const IS_SURVEY_TASK = { YES: 1, NO: 0 };

export const USE_OTHER_OPTION = { YES: 1, NO: 0 };

export const DISCARD_CHANGES_PRESSED = "discard_changes_pressed";
export const UPDATE_PRESSED = "update_pressed";

export const SUBSCRIPTION_PLAN_ENTERPRISE = 3;

export const TEST_DEVICE_COMPUTER_ONLY = 1;
export const TEST_DEVICE_TABLET_ONLY = 2;
export const TEST_DEVICE_MOBILE_ONLY = 3;
export const TEST_DEVICE_TABLET_AND_MOBILE = 4;
export const TEST_DEVICE_TABLET_IPAD_ONLY = 5; // ipad only

// Comments
export const FILTER_COMMENTS_ITEMS = {
  SHOW_RESOLVED_COMMENTS: "Show resolved comments",
  ALL_COMMENTS: "All Types",
  // CURRENT_TASK: "Current Task",
  UNREAD: "Unread",
  // LOW: "Low",
  // HIGH: "High",
  // CRITICAL: "Critical",
};

export const analysisSpaceTabs = [
  { key: ACTIVE_TAB_ALL, label: ACTIVE_TAB_ALL_LABEL },
  { key: ACTIVE_TAB_REELS, label: ACTIVE_TAB_REELS_LABEL },
  { key: ACTIVE_TAB_CLIPS, label: ACTIVE_TAB_CLIPS_LABEL },
  { key: ACTIVE_TAB_AREAS, label: ACTIVE_TAB_AREAS_LABEL },
  { key: ACTIVE_TAB_INSIGHTS, label: ACTIVE_TAB_INSIGHTS_LABEL },
];

export const COMMENT_MAX_LENGTH = 6000;

export const COMMENT_ENTITY_TYPE = {
  TASK: 0,
  SCREENER: 1,
  ANALYSIS_VIDEO_CLIP: 2,
  ANALYSIS_NOTES: 3,
  ANALYSIS_BOOKMARKS: 4,
  ANALYSIS_ANNOTATIONS: 5,
  ANALYSIS_TRANSCRIPTS: 6,
  ANALYSIS_TRANSLATION: 7,
};

const ANALYSIS_TO_COMMENT_TYPE_MAP = {
  [ANALYSIS_TYPE_VIDEO_CLIP]: COMMENT_ENTITY_TYPE.ANALYSIS_VIDEO_CLIP,
  [ANALYSIS_TYPE_NOTES]: COMMENT_ENTITY_TYPE.ANALYSIS_NOTES,
  [ANALYSIS_TYPE_BOOKMARKS]: COMMENT_ENTITY_TYPE.ANALYSIS_BOOKMARKS,
  [ANALYSIS_TYPE_ANNOTATIONS]: COMMENT_ENTITY_TYPE.ANALYSIS_ANNOTATIONS,
  [ANALYSIS_TYPE_TRANSCRIPTS]: COMMENT_ENTITY_TYPE.ANALYSIS_TRANSCRIPTS,
  [ANALYSIS_TYPE_TRANSLATION]: COMMENT_ENTITY_TYPE.ANALYSIS_TRANSLATION,
};

export const getAnalysisSpaceCommentEntityType = (analysisType) => ANALYSIS_TO_COMMENT_TYPE_MAP[analysisType] ?? null;

export const COMMENTS_TABS = {
  ALL_COMMENTS: "All Comments",
  FOR_YOU: "For You",
};

export const COMMENT_PRIORITY_LOW = 0;
export const COMMENT_PRIORITY_HIGH = 1;
export const COMMENT_PRIORITY_CRITICAL = 2;

export const COMMENT_STATUS_UNRESOLVED = 0;
export const COMMENT_STATUS_RESOLVED = 1;

export const COMMENT_NOT_DELETED = 0;
export const COMMENT_DELETED = 1;

export const COMMENTS_PRIORITY = {
  LOW: { id: COMMENT_PRIORITY_LOW, label: "Low", color: "#F5A42E", bgColor: "#FEFFE1" },
  HIGH: { id: COMMENT_PRIORITY_HIGH, label: "High", color: "#9B51E0", bgColor: "#F7EDFF" },
  CRITICAL: { id: COMMENT_PRIORITY_CRITICAL, label: "Critical", color: "#EB5757", bgColor: "#FFE1E1" },
};

export const ALLOWED_NATIONALITY_QUOTA_TYPES = ["nationality"];

export const PRODUCTS = {
  MODERATED: "moderated",
  UNMODERATED: "unmoderated",
  CARDSORTING: "cardsorting",
  TREETESTING: "treetesting",
  SURVEYS: "surveys",
  NORECORDING: "noRecording",
};

export const PRODUCT_TYPES = { MODERATED: 0, UNMODERATED: 1 };

// TOOLBOX PLAN TYPES
export const TOOLBOX_PLAN_TYPES = { FREE: 0, MONTHLY: 1, YEARLY: 2, ENTERPRISES: 3 };

export const TEMPLATE_FILTER_SEARCH = "TEMPLATE_FILTER_SEARCH";
export const TEMPLATE_FILTER_USABILITY_TESTING_GOALS = "TEMPLATE_FILTER_USABILITY_TESTING_GOALS";
export const TEMPLATE_FILTER_INDUSTRIES = "TEMPLATE_FILTER_INDUSTRIES";
export const TEMPLATE_FILTER_TAGS = "TEMPLATE_FILTER_TAGS";
export const TEMPLATE_FILTER_DEVICE_TYPES = "TEMPLATE_FILTER_DEVICE_TYPES";
export const TEMPLATE_FILTER_TEST_TYPES = "TEMPLATE_FILTER_TEST_TYPES";

export const DEVICE_FRAME_IPHONE_13_MINI = "iphone_13_mini";
export const DEVICE_FRAME_IPHONE_14 = "iphone_14";
export const DEVICE_FRAME_ANDROID_SMALL = "android_small";
export const DEVICE_FRAME_ANDROID_LARGE = "android_large";
export const DEVICE_FRAME_PREVIEW = "preview";

export const SAFETY_AREA_OFF = "safety_area_off";
export const SAFETY_AREA_IPHONE = "safety_area_iphone";
export const SAFETY_AREA_ANDROID_LT_13 = "safety_area_android_lt_13";
export const SAFETY_AREA_ANDROID_13 = "safety_area_android_13";

export const DEVICE_FRAMES = [
  {
    key: DEVICE_FRAME_IPHONE_13_MINI,
    label: "iPhone 13 mini",
    dimensions: {
      width: 375,
      height: 812,
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_IPHONE],
  },
  {
    key: DEVICE_FRAME_IPHONE_14,
    label: "iPhone 14",
    dimensions: {
      width: 390,
      height: 844,
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_IPHONE],
  },
  {
    key: DEVICE_FRAME_ANDROID_SMALL,
    label: "Android (small)",
    dimensions: {
      width: 360,
      height: 640,
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_ANDROID_LT_13, SAFETY_AREA_ANDROID_13],
  },
  {
    key: DEVICE_FRAME_ANDROID_LARGE,
    label: "Android (large)",
    dimensions: {
      width: 360,
      height: 800,
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_ANDROID_LT_13, SAFETY_AREA_ANDROID_13],
  },
  {
    key: DEVICE_FRAME_PREVIEW,
    label: "Preview",
    dimensions: {
      width: "100%",
      height: "100%",
      aspectRatio: "9/16",
    },
    safetyAreas: [SAFETY_AREA_OFF, SAFETY_AREA_IPHONE, SAFETY_AREA_ANDROID_13],
  },
];

export const SAFETY_AREAS = [
  {
    key: SAFETY_AREA_OFF,
    label: "Off",
    topArea: {
      height: 0,
      asset: null,
    },
    bottomArea: {
      height: 0,
      asset: null,
    },
  },
  {
    key: SAFETY_AREA_IPHONE,
    label: "iPhone",
    topArea: {
      height: 44,
      asset: "iphone_top_safe_area",
    },
    bottomArea: {
      height: 32,
      asset: "iphone_bottom_safe_area",
    },
  },
  {
    key: SAFETY_AREA_ANDROID_LT_13,
    label: "Android < 13",
    topArea: {
      height: 24,
      asset: "android_lt_13_top_safe_area",
    },
    bottomArea: {
      height: 48,
      asset: "android_lt_13_bottom_safe_area",
    },
  },
  {
    key: SAFETY_AREA_ANDROID_13,
    label: "Android 13",
    topArea: {
      height: 24,
      asset: "android_13_top_safe_area",
    },
    bottomArea: {
      height: 48,
      asset: "android_13_bottom_safe_area",
    },
  },
];

export const TESTER_TYPE = { PANEL: "uxarmy", OWN: "random", MIXED: "mixed" };
export const RESPONSE_ID_LABEL = "Response ID";
export const SELF_SOURCED_TESTER_LABEL = "Self-sourced";
// Mirrors User::RANDOM_PARTICIPANT_EMAIL (Yii `user/models/User.php`) — the placeholder every
// self-sourced tester's `users.email` column holds regardless of whether the "Email" demographics
// field was collected (TestController::actionGetLogID never writes a real collected email there, only
// into that response's own user_data snapshot). Used by report views to make sure this literal string
// never renders as if it were a real address, wherever a tester's email might get displayed.
export const RANDOM_PARTICIPANT_EMAIL = "random.participant@via.uxarmy.com";
export const GENDER_TYPE = { MALE: "M", FEMALE: "F", UNKNOWN: "U" };
export const GENDER_OPTIONS = [
  { value: GENDER_TYPE.MALE, label: "Male" },
  { value: GENDER_TYPE.FEMALE, label: "Female" },
  { value: GENDER_TYPE.UNKNOWN, label: "Unknown" },
];
export const PARTICIPANT_HUB_NAME = "Participant Hub";
export const PARTICIPANT_CONSENT_TOOLTIP =
  'Participants marked with "Consent" have given you permission to contact them for future usability studies or user interviews.';
// Contact-count boundary shared by manual add (row cap) and CSV import (sync vs background job).
export const CLIENT_CONTACT_IMPORT_ASYNC_THRESHOLD = 20;
export const TEST_COMPLETED = { NO: 0, YES: 1, RESET: 2, WITHOUT_VIDEO: 3, DISQUALIFIED: 6 };
export const SESSION_RESULT = {
  NULL: 0,
  FAIL: 3, //if both successurl and answer dont match
  SUCCESS: 1, //if both successurl and answer match
  UNCLASSIFIED: 2, //if any one of successurl and answer dont match
  UNCLASSIFIED_WRNG_URL: 21,
  UNCLASSIFIED_WRNG_ANS: 22,
  DIRECT_SUCCESS: 4,
  INDIRECT_SUCCESS: 5,
};
export const SESSION_RESULT_TEXT = {
  [SESSION_RESULT.NULL]: "No Criteria",
  [SESSION_RESULT.FAIL]: "Fail",
  [SESSION_RESULT.SUCCESS]: "Success",
  [SESSION_RESULT.UNCLASSIFIED]: "UnClassified",
  [SESSION_RESULT.UNCLASSIFIED_WRNG_URL]: "UnClassified - Wrong URL",
  [SESSION_RESULT.UNCLASSIFIED_WRNG_ANS]: "UnClassified - Wrong Answer",
  [SESSION_RESULT.DIRECT_SUCCESS]: "Direct Success",
  [SESSION_RESULT.INDIRECT_SUCCESS]: "Indirect Success",
};

export const PATHS_COLOR_MAP = {
  [SESSION_RESULT.FAIL]: "#fa8ba6",
  [SESSION_RESULT.SUCCESS]: "#25a95f",
  [SESSION_RESULT.DIRECT_SUCCESS]: "#25a95f",
  [SESSION_RESULT.INDIRECT_SUCCESS]: "#C28800",
  [SESSION_RESULT.NULL]: "#2f62e9",
};

export const BROWSER_TEST_PROGRESS = {
  LANGUAGE_SELECTION: "LANGUAGE_SELECTION",
  SCREENER: "SCREENER",
  NDA: "NDA",
  DEMOGRAPHICS: "DEMOGRAPHICS",
  WELCOME: "WELCOME",
  TASKS: "TASKS",
  SUS: "SUS",
  UPLOADING: "UPLOADING",
  THANK_YOU: "THANK_YOU",
  EXIT: "EXIT",
  DISQUALIFY: "DISQUALIFY",
  INIT_RECORDING: "INIT_RECORDING",
};

export const COMMENTS_PREVIEW_SOURCE = {
  BROWSER_TEST: "browserTest",
  TBT: "tbt",
};

export const FIGMA_TASK_NOT_STARTED = 0;
export const FIGMA_TASK_STARTED = 1;
export const FIGMA_TASK_PAUSED = 2;

export const MAX_TESTER_INVITES_REC_ON = 150;
export const MAX_TESTER_INVITES_REC_OFF = 350;

export const MODERATED_DEFAULT_DEBRIEFING_TIME = 15; // in minutes
export const MODERATED_SESSION_TYPE = { DEEPDIVE: "DEEPDIVE", EXTERNAL_UPLOADED: "EXTERNAL_UPLOADED", AI_MODERATED: "AI_MODERATED" };
// `log_status` on a session - mirrors TestLog::COMPLETED_* on the server
export const TEST_LOG_STATUS = { ON_HOLD: 5 };
export const MODERATED_PARTICIPANT_ROLE = {
  RECORDER: "RECORDER",
  OBSERVER: "OBSERVER",
  MODERATOR: "MODERATOR",
  TRANSLATOR: "TRANSLATOR",
  NOTE_TAKER: "NOTE_TAKER",
  PARTICIPANT: "PARTICIPANT",
  "Co-Facilitator": "Co-Facilitator",
  "Co-Moderator": "Co-Moderator",
};

export const HEATMAP_EVENTS_TYPES = {
  CLICK: "c",
  HOVER: "m",
};

export const HEATMAP_TYPES = {
  CLICK_MAP: {
    id: "click_map",
    name: "Click Map",
    icon: "click_heatmap",
    tabIcon: "click_heatmap_icon",
    events: [HEATMAP_EVENTS_TYPES.CLICK],
    available: [
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.TABLET, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.MOBILE, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.ANY, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.EXTERNAL_PROTOTYPE },
      { device: DEVICE_TYPE.MOBILE, task: TASK_TYPES.EXTERNAL_PROTOTYPE },
      { device: DEVICE_TYPE.TABLET, task: TASK_TYPES.EXTERNAL_PROTOTYPE },
      { device: DEVICE_TYPE.ANY, task: TASK_TYPES.EXTERNAL_PROTOTYPE },
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.FIRSTCLICK },
      { device: DEVICE_TYPE.MOBILE, task: TASK_TYPES.FIRSTCLICK },
      { device: DEVICE_TYPE.TABLET, task: TASK_TYPES.FIRSTCLICK },
      { device: DEVICE_TYPE.ANY, task: TASK_TYPES.FIRSTCLICK },
    ],
  },
  HOVER_MAP: {
    id: "hover_map",
    name: "Hover Map",
    icon: "hover_heatmap",
    tabIcon: "hover_heatmap_icon",
    events: [HEATMAP_EVENTS_TYPES.HOVER],
    available: [
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.EXTERNAL_PROTOTYPE, excludedPrototypeSources: [SOURCE_FIGMA] },
    ],
  },
  MOUSE_MAP: {
    id: "mouse_map",
    name: "Mouse Map",
    icon: "mouse_map",
    tabIcon: "mouse_map_icon",
    events: [HEATMAP_EVENTS_TYPES.CLICK, HEATMAP_EVENTS_TYPES.HOVER],
    available: [
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.DEFAULT },
      { device: DEVICE_TYPE.COMPUTER, task: TASK_TYPES.EXTERNAL_PROTOTYPE, excludedPrototypeSources: [SOURCE_FIGMA] },
    ],
  },
};

export const AI_SUMMARY_STATUS = { NOT_SENT: 0, PENDING: 1, COMPLETED: 2, NO_ENOUGH_DATA: 4, FAILED: 5 };
export const AI_SECTION_TYPES = { TEXT: "TEXT", VERBATIM: "VERBATIM", SUMMARY: "SUMMARY" };
export const SENTIMENT_TYPES = { POSITIVE: "POSITIVE", NEGATIVE: "NEGATIVE", NEUTRAL: "NEUTRAL" };
export const USER_ROLES = {
  ADMIN: "admin",
  READ: "read",
  WRITE: "write",
  OWNER: "owner",
  COLLABORATOR: "collab",
};

export const USER_INVITE_STATUS = { ACCEPTED: "accepted", PENDING: "pending" };

export const INVITE_TYPE = {
  TEST: "test",
  PROJECT: "project",
  TEAM: "team",
  WORKSPACE: "workspace",
  ORGANIZATION: "organization",
};

// Toolkit Constants
export const TOOLKIT = {
  TEST_TYPES: { treetest: 0, participatorydesign: 1, cardsort: 2 },
};

export const PLANS = {
  FREE: "free",
  ESSENTIALS: "essentials",
  PRO: "pro",
  ENTERPRISE: "enterprise",
};

export const ACTIVITY_PAGE_SIZE = 5;

export const DEEPDIVE_ROLE_ICONS = {
  Observer: "glasses-02",
  Participant: "user-01",
  Translator: "translate",
  Moderator: "headphones",
  "Note Taker": "pencil-line",
  "Co-facilitator": "headphones",
  "Co-moderator": "headphones",
};

export const DEEPDIVE_SESSION_MODE = {
  INDIVIDUAL: {
    key: 0,
    label: "1:1 Interview",
    image: INDIVIDUAL_ICON,
    desc: "only 1 participant to join",
    desc2: "Interview with a participant",
  },
  DYAD: { key: 1, label: "Dyad", image: DYAD_ICON, desc: "maximum 2 participants to join", desc2: "Interview with 2 participants" },
  TRIAD: {
    key: 2,
    label: "Triad",
    image: TRIAD_ICON,
    desc: "maximum 3 participants to join",
    desc2: "Triad, Interview with 3 participants",
  },
  FOCUS_GROUP: { key: 3, label: "Focus Group", image: FOCUS_GROUP_ICON, desc: "maximum 10 participants to join", desc2: "" },
};

// Toolkit Test Status
export const TOOLKIT_TEST_STATUS = { DRAFT: 0, ACTIVE: 1, INACTIVE: 2, EDIT: 3, COMPLETED: 4, DELETED: 5 };

// Participant database (PM) invitee status — mirrors NestJS CLIENT_CONTACT.INVITEE_STATUS
export const CLIENT_CONTACT_INVITEE_STATUS = {
  PENDING: "pending",
  INVITED: "invited",
  CLICKED: "clicked",
  RESPONDED: "responded",
  BOUNCED: "bounced",
  CANCELLED: "cancelled",
};

// Yii test-runner's uxarmy_custom_tracking_links.status — richer than CLIENT_CONTACT_INVITEE_STATUS
// once a tester has actually started (screener/quota outcome, in progress, completed). Labels
// mirror CustomTrackingLinks.php's $linkStatusLabels so the wording matches existing admin reports.
export const TRACKING_LINK_STATUS = {
  NEW: "NEW",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  SCREENED_OUT: "SCREENED_OUT",
  QUOTA_FULL: "QUOTA_FULL",
  INVALIDATED: "INVALIDATED",
};

export const TRACKING_LINK_STATUS_LABEL = {
  [TRACKING_LINK_STATUS.NEW]: "In progress",
  [TRACKING_LINK_STATUS.IN_PROGRESS]: "In progress",
  [TRACKING_LINK_STATUS.COMPLETED]: "Completed",
  [TRACKING_LINK_STATUS.SCREENED_OUT]: "Screened out",
  [TRACKING_LINK_STATUS.QUOTA_FULL]: "Quota full",
  [TRACKING_LINK_STATUS.INVALIDATED]: "Invalidated",
};

// Plain-language labels for a contact's invite/delivery state — not a 1:1 enum map like the one above
// (e.g. "Invited" covers invited/clicked/responded, "Not Invited" covers pending-and-not-sending), but
// reused as-is by both SelectParticipantsModal's Status column and ContactHistoryModal's Outcome column
// so the wording can't drift between the two again.
export const INVITE_DISPLAY_LABEL = {
  INVITED: "Invited",
  NOT_INVITED: "Not Invited",
  // ContactHistoryModal opens from the "# Invited" count, so a plain "Not Invited" there would read as
  // contradicting the very count the user clicked — this is specific to that context.
  ADDED_NOT_INVITED: "Added but not invited yet",
  SENDING: "Sending...",
  FAILED: "Failed Invite",
};

export const INTEGRATIONS = { SLACK: 0, GOOGLE_SHEETS: 1, FIGMA: 2, MIRO: 3 };

export const PLAN_FEE_TYPE = { FREE: 0, PAID: 1, MANUAL: 2, TRIAL: 3 };
export const PLAN_RECURRING_TYPE = { MONTH: "month", YEAR: "year" };
export const ORGANIZATION_TEAM_SIZE = { SMALL_1: 1, SMALL_2_10: 2, MEDIUM_11_50: 3, MEDIUM_51_100: 4, LARGE_100_PLUS: 5 };

export const PURPOSE = {
  SUBSCRIPTION_START: 1,
  SUBSCRIPTION_RENEWAL: 2,
  TEST_CREATION: 3,
  TEST_PARTICIPATION: 4,
  BONUS: 5,
  ADMIN: 6,
  TOPUP: 7,
  REFUND: 10,
  SUBSCRIPTION_UPGRADE: 11,
  FREE_PLAN_ACTIVATED: 12,
};

export const INVITE_ERROR_CODES = {
  SUCCESS: "SUCCESS",
  INVALID: "INVALID",
  EXPIRED: "EXPIRED",
  NOT_FOUND: "NOT_FOUND",
  UNAUTHORIZED: "UNAUTHORIZED",
  ALREADY_MEMBER: "ALREADY_MEMBER",
  ALREADY_ACCEPTED: "ALREADY_ACCEPTED",
  MAX_INVITES_REACHED: "MAX_INVITES_REACHED",
  INVALID_RESOURCE_TYPE: "INVALID_RESOURCE_TYPE",
};

export const MAX_ALLOWED_AI_FOLLOW_UP_QUESTIONS = 3;
export const MODERATED_EVENT_STATUS = { BOOKED: "booked", CANCELLED: "cancelled" };
export const MODERATED_SESSION_STATUS = { ACTIVE: 1, INACTIVE: 0, COMPLETED: 2, DELETED: 3 };

export const GREETING_TYPE = {
  WELCOME: "intro",
  THANK_YOU: "complete",
  QUOTAFULL: "quotafull",
  DISQUALIFICATION: "disqualification",
};

export const SHUFFLE_OPTIONS_TYPES = { NONE: 0, ALL: 1, SHUFFLE_SPECIFIC_OPTIONS: 2 };
export const OPTIONS_PINNED_TYPE = { TOP: 0, BOTTOM: 1, NONE: 2 };
export const RECORDING_MODES = { AUDIO: "AUDIO", SCREEN: "SCREEN", CAMERA: "CAMERA" };

export const ANALYSIS_SPACE_USER_TYPE = { MODERATOR: "moderator", PARTICIPANT: "participant" };
export const CARRY_FORWARD_ANS_TYPE_TO_USE = {
  ALL: "all",
  ANSWERED: "answered",
  UNANSWERED: "unanswered",
};

export const FEED_MODE = { BRIEFING: "BRIEFING", DEBRIEFING: "DEBRIEFING", IN_SESSION: "IN_SESSION" };

export const ALL_SESSIONS = "ALL_SESSIONS";
export const SCHEDULED_USER_INTERVIEWS = "SCHEDULED_USER_INTERVIEWS";
export const MODERATED_SUMMARY = "MODERATED_SUMMARY";
export const DISCUSSION_GUIDE = "DISCUSSION_GUIDE";

// Key of the study-wide subtab on the moderated report's Summary tab. Every other subtab is
// keyed by its AI interview event id.
export const OVERALL_SUMMARY_KEY = "OVERALL";

export const RECENT_TESTS_MAP_KEY = "recentTestsMap";

export const FONTS = [
  // System-safe buckets
  { value: "sans-serif", label: "Sans Serif", css: "Arial, Helvetica, sans-serif" },
  { value: "serif", label: "Serif", css: '"Times New Roman", Times, serif' },
  { value: "monospace", label: "Monospace", css: '"Courier New", Courier, monospace' },

  // System families
  { value: "arial", label: "Arial", css: "Arial, Helvetica, sans-serif" },
  { value: "helvetica", label: "Helvetica", css: "Helvetica, Arial, sans-serif" },
  { value: "georgia", label: "Georgia", css: 'Georgia, "Times New Roman", serif' },
  { value: "times-new-roman", label: "Times New Roman", css: '"Times New Roman", Times, serif' },
  { value: "courier-new", label: "Courier New", css: '"Courier New", Courier, monospace' },
  { value: "tahoma", label: "Tahoma", css: "Tahoma, Verdana, sans-serif" },
  { value: "verdana", label: "Verdana", css: "Verdana, Tahoma, sans-serif" },

  // Popular web fonts (load via <link> or @import)
  { value: "inter", label: "Inter", css: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' },
  { value: "roboto", label: "Roboto", css: 'Roboto, system-ui, -apple-system, "Segoe UI", Helvetica, Arial, sans-serif' },
  { value: "open-sans", label: "Open Sans", css: '"Open Sans", Helvetica, Arial, sans-serif' },
  { value: "lato", label: "Lato", css: "Lato, Helvetica, Arial, sans-serif" },
  { value: "montserrat", label: "Montserrat", css: 'Montserrat, "Helvetica Neue", Helvetica, Arial, sans-serif' },
  { value: "poppins", label: "Poppins", css: 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif' },
  { value: "nunito", label: "Nunito", css: 'Nunito, "Helvetica Neue", Helvetica, Arial, sans-serif' },
  { value: "rubik", label: "Rubik", css: 'Rubik, "Helvetica Neue", Helvetica, Arial, sans-serif' },
  { value: "source-sans-3", label: "Source Sans 3", css: '"Source Sans 3", "Helvetica Neue", Helvetica, Arial, sans-serif' },
  { value: "merriweather", label: "Merriweather", css: 'Merriweather, Georgia, "Times New Roman", serif' },
];

export const DEEPDIVE_SESSION_STATE = {
  NOT_FOUND: "NOT_FOUND",
  ONGOING: "ONGOING",
  VIDEO_PROCESSING: "VIDEO_PROCESSING",
  VIDEO_TRANSCRIBING: "VIDEO_TRANSCRIBING",
  COMPLETED: "COMPLETED",
};

export const NORECORDING_RECORDING_MODES = { NONE: "NONE", AUDIO_ONLY: "AUDIO", CAMERA_AND_AUDIO: "CAMERA_AND_AUDIO" };

export const REPORT_CUSTOM_FILTER_TYPES = {
  NONE: "NONE",
  TASK_DURATION: "TASK_DURATION",
  SUCCESS_CRITERIA: "SUCCESS_CRITERIA",
  CONTAINS: "CONTAINS",
  CONDITION: "CONDITION",
};

export const REPORT_DEFAULT_FILTERS = {
  source: "all",
  totalDuration: "all",
  participantIds: [],
  ageRange: "all",
  gender: "all",
  nationality: [],
  custom: {
    rules: [], // [{ joiner, questionId, condition, optionId, text, successCriteria, taskDuration }]
  },
  screener: {
    rules: [], // [{ questionId, optionIds, match }]
  },
};

export const REPORT_FILTERS_EVENT = "reportFiltersChanged";

export const INTEGRATION_PAGE_REPORT = "report";
export const INTEGRATION_PAGE_ANALYSIS = "analysis";

export const FIGMA_ACCESS_LEVEL = {
  PUBLIC: "public",
  PASSWORD_PROTECTED: "password_protected",
  UNKNOWN: "unknown",
};
export const CARD_SORT_TYPES = { OPEN: 0, CLOSED: 1, HYBRID: 2 };
export const REQUIRE_EXPLANATION = { NO: 0, YES: 1, OPTIONAL: 2 };
export const RESPONSE_RESULTS = {
  DIRECT_SUCCESS: 1,
  INDIRECT_SUCCESS: 2,
  DIRECT_FAILURE: 3,
  INDIRECT_FAILURE: 4,
  DIRECT_SKIPPED: 5,
  INDIRECT_SKIPPED: 6,
};

export const TASK_COMPLETION_TIME = {
  DEFAULT: 60, // in seconds
  FIVE: 5, // in seconds
};

export const OTHER_COUNTRY = "Other";

export const DEFAULT_DEMOGRAPHICS_CONFIG = [
  { id: "name", label: "Name", enabled: true },
  { id: "dob", label: "Year of Birth", enabled: true },
  { id: "gender", label: "Gender", enabled: true },
  { id: "nationality", label: "Nationality", enabled: true },
  // Off by default — unlike the four above, this is a new field being added to already-configured/
  // running tests; defaulting it on would silently start demanding an email from testers mid-study on
  // every test that never opted in. New tests can still turn it on same as any other field.
  { id: "email", label: "Email", enabled: false },
];

export const LAYOUT_PLACEMENT = {
  CENTER: "center",
  LEFT: "left",
};

export const PROTOTYPE_SCALING = {
  MIN_ZOOM: "min-zoom",
  SCALE_DOWN: "scale-down",
  CONTAIN: "contain",
  SCALE_DOWN_WIDTH: "scale-down-width",
};

export const PROTOTYPE_SCALING_OPTIONS = [
  { value: PROTOTYPE_SCALING.MIN_ZOOM, label: "100% - Display at full size" },
  { value: PROTOTYPE_SCALING.SCALE_DOWN, label: "Fit - Scale down to fit" },
  { value: PROTOTYPE_SCALING.CONTAIN, label: "Fill - Scale down or up to fill" },
  { value: PROTOTYPE_SCALING.SCALE_DOWN_WIDTH, label: "Width - Scale down to fit width" },
];

export const CARRY_FORWARD_TOOLTIP = "Carry forward lets you show options a participant picked earlier as choices in this question.";
export const ANSWER_PIPING_TOOLTIP = "Answer piping inserts a participant's earlier answer as text within this question.";

export const STUDY_LANGUAGE_NO_LANG = "Let participant choose";
